import { render, staticRenderFns } from "./PagosCobranza.vue?vue&type=template&id=ee6ba942&scoped=true&"
import script from "./PagosCobranza.vue?vue&type=script&lang=js&"
export * from "./PagosCobranza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6ba942",
  null
  
)

export default component.exports